import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@aqarmap/aqarmap-ui';
import { Languages } from '~/constants/enums';

type Props = {
  title: string;
  imgStillProcessing?: boolean;
  getImageFile: (file: File) => void;
};

const AddNewImage = ({ title, imgStillProcessing, getImageFile }: Props) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const { i18n, t } = useTranslation('app');
  const locale = i18n.language;
  const inputRef = useRef<HTMLInputElement>(null);
  const handleCameraClick = () => {
    inputRef.current?.click();
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = event.target.files as FileList;
    const image = files[0] as File;
    if (image.type.startsWith('image')) {
      getImageFile(image);
      setSelectedImage(URL.createObjectURL(image as File));
    }
  };
  return (
    <div className="w-fit">
      <h4 className="text-title_4 mb-2x font-[600]">{title}</h4>
      <div className="relative cursor-pointer" onClick={handleCameraClick}>
        <input
          ref={inputRef}
          type="file"
          title="upload-img"
          onChange={handleImageUpload}
          className="absolute -z-10 inset-0 w-full h-full opacity-0 rounded-full cursor-pointer"
          aria-label="Choose file"
          accept="image/*"
        />
        {selectedImage ? (
          <img
            src={selectedImage}
            alt="Account-Img"
            className="w-[120px] h-[120px] rounded-full object-contain border border-gray"
          />
        ) : (
          <div className="rounded-full bg-gray_light_1 border border-gray w-[120px] h-[120px] element-center">
            <Icon name="user" className="text-gray__dark_1" size="32px" />
          </div>
        )}

        <span
          className={`absolute ${locale === Languages.ENGLISH ? 'left-0' : 'right-0'} bottom-0 bg-white w-[32px] h-[32px] border border-gray rounded-full element-center`}
        >
          <Icon name="camera" className="text-gray__dark_1" />
        </span>
      </div>
      {imgStillProcessing && (
        <p className="text-body_2 mt-x w-full bg-orange_light_2 text-orange_dark_2 font-normal p-1.5x rounded-[8px] mb-3x">
          {t('app:imageStillProcessing')}
        </p>
      )}
    </div>
  );
};

export default AddNewImage;
